/**
 * 所有的全局判断方法，提供给所有vue实例调用
 */
export default {
  /**
   * 是否是个人版本
   * @returns
   */
  isPersonVersion() {
    return process.env.VUE_APP_VERSION_TYPE == 'PERSON'
  },

  /**
   * 判断是否是免费时间
   */
  isVip() {
    const userInfo = localStorage.getItem('info')
    if (!userInfo) {
      return false
    }
    const user = JSON.parse(userInfo)
    return Number(user.user.vipExpireTime) >= new Date().getTime()
  },

  isLessThreeDay() {
    const userInfo = localStorage.getItem('info')
    if (!userInfo) {
      return false
    }
    const user = JSON.parse(userInfo)
    const deltaTime = Number(user.user.vipExpireTime) - new Date().getTime()
    return deltaTime < 3 * 24 * 60 * 60 * 1000 && deltaTime > 0
  },

  /**
   * 判断是否需要新手指引
   * @returns
   */
  isOldPlayer() {
    return localStorage.getItem('oldPlayer')
  },
}
